// untils/LanguageInfo

import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const LanguageTestComponent = () => (
    <Box component={Paper} sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>Spouse's Language Proficiency</Typography>
        <Typography paragraph>
            If you are applying with a spouse or common-law partner, their language proficiency can contribute up to 20 points to your overall CRS score.
        </Typography>
        <Typography paragraph>
            To claim these points, your spouse or partner must take one of the designated language tests. The points are awarded based on their Canadian Language Benchmark (CLB) level for their first official language.
        </Typography>
    </Box>
);

export default LanguageTestComponent;
